// MA: novidades de cada versão, escritas para o cliente (quem atende), não para
// quem opera o servidor. A versão é a do MA (config/app.yml, versionMA).
// Toda versão publicada que muda algo visível para o cliente ganha uma entrada
// aqui, no topo, na mesma PR da release, com título e descrição em pt_BR, en e
// es (a tela segue o idioma da interface). Tipos: 'new', 'improvement', 'fix'.
export default [
  {
    version: '4.11.2',
    date: '2026-10-22',
    highlights: [
      {
        type: 'fix',
        title: {
          pt_BR: 'Conversas não ficam mais escondidas depois do robô',
          en: 'Conversations no longer stay hidden after the bot',
          es: 'Las conversaciones ya no quedan ocultas después del bot',
        },
        description: {
          pt_BR:
            'Quando o robô encerrava o atendimento por falta de resposta, a conversa podia continuar presa a ele: não aparecia em "Não atribuídas" e não era distribuída aos agentes. Agora ela volta para a fila normalmente.',
          en: 'When the bot ended a conversation because the customer stopped replying, the conversation could stay tied to it: it did not show up in "Unassigned" and was not distributed to agents. Now it goes back to the queue as expected.',
          es: 'Cuando el bot cerraba la atención por falta de respuesta, la conversación podía quedar ligada a él: no aparecía en "No asignadas" y no se distribuía a los agentes. Ahora vuelve a la fila normalmente.',
        },
      },
    ],
  },
  {
    version: '4.11.0',
    date: '2026-10-21',
    highlights: [
      {
        type: 'new',
        title: {
          pt_BR: 'Novidades a cada versão',
          en: "What's new in every version",
          es: 'Novedades en cada versión',
        },
        description: {
          pt_BR:
            'Esta tela aparece uma vez a cada atualização do MA. Para rever, abra o menu do seu perfil e clique em Novidades.',
          en: 'This screen shows up once after each MA update. To see it again, open your profile menu and click What’s new.',
          es: 'Esta pantalla aparece una vez después de cada actualización del MA. Para volver a verla, abre el menú de tu perfil y haz clic en Novedades.',
        },
      },
      {
        type: 'new',
        title: {
          pt_BR: 'Quem recebe as respostas da campanha',
          en: 'Who gets campaign replies',
          es: 'Quién recibe las respuestas de la campaña',
        },
        description: {
          pt_BR:
            'Ao criar ou editar uma campanha, escolha quem atende as respostas: a regra da caixa de entrada, um rodízio entre os agentes da caixa, um time ou um agente específico.',
          en: 'When creating or editing a campaign, choose who handles the replies: the inbox rule, a rotation among the inbox agents, a team or a specific agent.',
          es: 'Al crear o editar una campaña, elige quién atiende las respuestas: la regla de la bandeja de entrada, una rotación entre los agentes de la bandeja, un equipo o un agente específico.',
        },
      },
      {
        type: 'new',
        title: {
          pt_BR: '"Digitando..." no WhatsApp do cliente',
          en: '"Typing..." on the customer’s WhatsApp',
          es: '"Escribiendo..." en el WhatsApp del cliente',
        },
        description: {
          pt_BR:
            'Nas caixas de WhatsApp, o cliente pode ver "digitando..." enquanto você escreve e "gravando áudio..." enquanto grava. Para ligar, vá em Configurações da caixa de entrada e ative "Mostrar digitando ao cliente".',
          en: 'In WhatsApp inboxes, the customer can see "typing..." while you write and "recording audio..." while you record. To turn it on, open the inbox settings and enable "Show typing to the customer".',
          es: 'En las bandejas de WhatsApp, el cliente puede ver "escribiendo..." mientras escribes y "grabando audio..." mientras grabas. Para activarlo, abre la configuración de la bandeja de entrada y activa "Mostrar escribiendo al cliente".',
        },
      },
      {
        type: 'new',
        title: {
          pt_BR: 'Sugestão de resposta com IA',
          en: 'AI reply suggestions',
          es: 'Sugerencia de respuesta con IA',
        },
        description: {
          pt_BR:
            'Nas contas com o Captain ativo, o botão de estrela no editor sugere uma resposta com base na conversa. O texto aparece no editor para você revisar antes de enviar.',
          en: 'In accounts with Captain enabled, the star button in the editor suggests a reply based on the conversation. The text appears in the editor for you to review before sending.',
          es: 'En las cuentas con Captain activo, el botón de estrella del editor sugiere una respuesta basada en la conversación. El texto aparece en el editor para que lo revises antes de enviarlo.',
        },
      },
      {
        type: 'fix',
        title: {
          pt_BR: 'Nome do robô nas mensagens',
          en: 'Bot name in messages',
          es: 'Nombre del bot en los mensajes',
        },
        description: {
          pt_BR:
            'Nas caixas que mostram o nome do agente na mensagem, os robôs voltam a conseguir enviar mensagens, assinadas com o nome do robô.',
          en: 'In inboxes that show the agent name in messages, bots can send messages again, signed with the bot’s name.',
          es: 'En las bandejas que muestran el nombre del agente en el mensaje, los bots vuelven a poder enviar mensajes, firmados con el nombre del bot.',
        },
      },
      {
        type: 'fix',
        title: {
          pt_BR: 'Relatório de uso de IA em dia',
          en: 'Up-to-date AI usage report',
          es: 'Informe de uso de IA al día',
        },
        description: {
          pt_BR:
            'O consumo de IA que chegava atrasado da OpenAI deixa de sumir do relatório.',
          en: 'AI usage that arrived late from OpenAI no longer goes missing from the report.',
          es: 'El consumo de IA que llegaba con retraso desde OpenAI ya no desaparece del informe.',
        },
      },
    ],
  },
  {
    version: '4.10.0',
    date: '2026-10-18',
    highlights: [
      {
        type: 'improvement',
        title: {
          pt_BR: 'Lista de conversas mais estável',
          en: 'A steadier conversation list',
          es: 'Lista de conversaciones más estable',
        },
        description: {
          pt_BR:
            'Mensagens antigas não aparecem mais ao trocar de conversa, e os atalhos de teclado não disparam duas vezes.',
          en: 'Old messages no longer show up when you switch conversations, and keyboard shortcuts no longer fire twice.',
          es: 'Los mensajes antiguos ya no aparecen al cambiar de conversación y los atajos de teclado ya no se activan dos veces.',
        },
      },
      {
        type: 'new',
        title: {
          pt_BR: 'Ordenar conversas filtradas',
          en: 'Sort filtered conversations',
          es: 'Ordenar conversaciones filtradas',
        },
        description: {
          pt_BR:
            'Depois de aplicar um filtro, você escolhe a ordem das conversas da lista.',
          en: 'After applying a filter, you can choose how the conversations in the list are sorted.',
          es: 'Después de aplicar un filtro, puedes elegir el orden de las conversaciones de la lista.',
        },
      },
      {
        type: 'new',
        title: {
          pt_BR: 'Abrir itens do menu em nova aba',
          en: 'Open menu items in a new tab',
          es: 'Abrir elementos del menú en una pestaña nueva',
        },
        description: {
          pt_BR:
            'Clique com o botão do meio, ou segure Ctrl ao clicar, para abrir uma tela do menu lateral em outra aba.',
          en: 'Middle-click, or hold Ctrl while clicking, to open a sidebar page in another tab.',
          es: 'Haz clic con el botón central, o mantén Ctrl al hacer clic, para abrir una pantalla del menú lateral en otra pestaña.',
        },
      },
      {
        type: 'new',
        title: {
          pt_BR: 'Outras conversas do contato',
          en: "The contact's other conversations",
          es: 'Otras conversaciones del contacto',
        },
        description: {
          pt_BR:
            'Na conversa aberta, dá para navegar direto pelas outras conversas do mesmo contato.',
          en: 'From the open conversation, you can jump straight to the same contact’s other conversations.',
          es: 'Desde la conversación abierta, puedes ir directamente a las otras conversaciones del mismo contacto.',
        },
      },
      {
        type: 'new',
        title: {
          pt_BR: 'Nome de usuário do WhatsApp',
          en: 'WhatsApp username',
          es: 'Nombre de usuario de WhatsApp',
        },
        description: {
          pt_BR:
            'O painel do contato mostra o nome de usuário do WhatsApp, quando o contato tem um.',
          en: 'The contact panel shows the WhatsApp username when the contact has one.',
          es: 'El panel del contacto muestra el nombre de usuario de WhatsApp cuando el contacto tiene uno.',
        },
      },
      {
        type: 'improvement',
        title: {
          pt_BR: 'Automações com espera aceitam condições',
          en: 'Delayed automations accept conditions',
          es: 'Las automatizaciones con espera aceptan condiciones',
        },
        description: {
          pt_BR:
            'As automações que aguardam um tempo antes de agir agora podem conferir condições antes de executar.',
          en: 'Automations that wait before acting can now check conditions before they run.',
          es: 'Las automatizaciones que esperan antes de actuar ahora pueden verificar condiciones antes de ejecutarse.',
        },
      },
      {
        type: 'improvement',
        title: {
          pt_BR: 'Mais segurança nas mensagens',
          en: 'Safer messages',
          es: 'Mensajes más seguros',
        },
        description: {
          pt_BR:
            'O conteúdo das mensagens passa por uma verificação extra contra códigos maliciosos.',
          en: 'Message content now goes through an extra check against malicious code.',
          es: 'El contenido de los mensajes pasa por una verificación adicional contra código malicioso.',
        },
      },
    ],
  },
  {
    version: '4.9.0',
    date: '2026-10-16',
    highlights: [
      {
        type: 'fix',
        title: {
          pt_BR: 'Telefone com o 55 repetido é corrigido sozinho',
          en: 'Phone numbers with a repeated 55 are fixed automatically',
          es: 'Los teléfonos con el 55 repetido se corrigen solos',
        },
        description: {
          pt_BR:
            'Ao escolher o Brasil (+55) e digitar o número já com 55, o contato era salvo com um número que não existe, e a resposta do cliente caía em outro contato. Agora o 55 a mais é removido ao salvar, e a tela avisa se o contato já existe.',
          en: 'Choosing Brazil (+55) and typing the number with 55 already in it saved the contact with a number that does not exist, so the customer’s reply went to another contact. The extra 55 is now removed on save, and you are warned if the contact already exists.',
          es: 'Al elegir Brasil (+55) y escribir el número ya con 55, el contacto se guardaba con un número inexistente y la respuesta del cliente llegaba a otro contacto. Ahora el 55 sobrante se elimina al guardar y la pantalla avisa si el contacto ya existe.',
        },
      },
      {
        type: 'fix',
        title: {
          pt_BR: 'Contatos sem telefone ganharam o número',
          en: 'Contacts without a phone number now show it',
          es: 'Los contactos sin teléfono ahora muestran el número',
        },
        description: {
          pt_BR:
            'Contatos do WhatsApp que apareciam com um código no lugar do telefone passaram a mostrar o número real.',
          en: 'WhatsApp contacts that showed a code instead of a phone number now show the real number.',
          es: 'Los contactos de WhatsApp que mostraban un código en lugar del teléfono ahora muestran el número real.',
        },
      },
      {
        type: 'improvement',
        title: {
          pt_BR: 'Editor de robôs CSML mais largo',
          en: 'Wider CSML bot editor',
          es: 'Editor de bots CSML más ancho',
        },
        description: {
          pt_BR:
            'O editor ocupa a largura toda da tela, com nome, descrição e o botão Salvar numa barra acima dele.',
          en: 'The editor now uses the full width of the screen, with the name, description and Save button in a bar above it.',
          es: 'El editor ocupa todo el ancho de la pantalla, con el nombre, la descripción y el botón Guardar en una barra encima.',
        },
      },
    ],
  },
  {
    version: '4.8.0',
    date: '2026-10-07',
    highlights: [
      {
        type: 'new',
        title: {
          pt_BR: 'Robô TalkEditor',
          en: 'TalkEditor bot',
          es: 'Bot de TalkEditor',
        },
        description: {
          pt_BR:
            'Novo tipo de robô que atende com um fluxo do TalkEditor. Os botões de escolha chegam ao cliente como botões e, quando o fluxo termina, a conversa vai para os atendentes.',
          en: 'A new bot type that answers with a TalkEditor flow. Choice buttons reach the customer as buttons, and when the flow ends the conversation goes to your agents.',
          es: 'Nuevo tipo de bot que atiende con un flujo de TalkEditor. Los botones de opción llegan al cliente como botones y, cuando el flujo termina, la conversación pasa a los agentes.',
        },
      },
      {
        type: 'fix',
        title: {
          pt_BR: 'Robôs do n8n não largam mais conversas sem motivo',
          en: 'n8n bots no longer drop conversations for no reason',
          es: 'Los bots de n8n ya no abandonan conversaciones sin motivo',
        },
        description: {
          pt_BR:
            'Um fluxo que decide não responder não é mais tratado como erro, e fluxos mais demorados têm mais tempo para responder.',
          en: 'A flow that decides not to reply is no longer treated as an error, and slower flows get more time to answer.',
          es: 'Un flujo que decide no responder ya no se trata como un error, y los flujos más lentos tienen más tiempo para responder.',
        },
      },
      {
        type: 'fix',
        title: {
          pt_BR: 'Mensagens do WhatsApp que não chegavam',
          en: 'WhatsApp messages that were not arriving',
          es: 'Mensajes de WhatsApp que no llegaban',
        },
        description: {
          pt_BR:
            'Mensagens de alguns clientes voltaram a entrar no MA, e quem entra ou sai de um grupo pelo celular volta a aparecer na conversa.',
          en: 'Messages from some customers are coming in again, and people joining or leaving a group from their phone show up in the conversation again.',
          es: 'Los mensajes de algunos clientes vuelven a entrar, y quien entra o sale de un grupo desde el celular vuelve a aparecer en la conversación.',
        },
      },
      {
        type: 'improvement',
        title: {
          pt_BR: 'Mídia que não pôde ser baixada',
          en: 'Media that could not be downloaded',
          es: 'Archivos que no se pudieron descargar',
        },
        description: {
          pt_BR:
            'Quando o WhatsApp não entrega uma mídia, a mensagem aparece com a legenda e um aviso, em vez de sumir.',
          en: 'When WhatsApp does not deliver a media file, the message shows up with its caption and a notice instead of disappearing.',
          es: 'Cuando WhatsApp no entrega un archivo, el mensaje aparece con su texto y un aviso, en lugar de desaparecer.',
        },
      },
    ],
  },
];
